// src/auth/gateConfig.js
import {
  PLANS,
  NASCAR_ALL,
  MLB_ALL,
  NFL_ALL,
  NBA_ALL,
} from "./plans";

/* ================= PRO PLAN ACCESS ================= */

const NASCAR_PRO_ACCESS = [PLANS.NASCAR_PRO, PLANS.ALL_ACCESS_PRO];
const NFL_PRO_ACCESS = [PLANS.NFL_PRO, PLANS.ALL_ACCESS_PRO];
const NBA_PRO_ACCESS = [PLANS.NBA_PRO, PLANS.ALL_ACCESS_PRO];
const MLB_PRO_ACCESS = [PLANS.MLB_PRO, PLANS.ALL_ACCESS_PRO];

/* ================= PROMO UNLOCKS ================= */

/**
 * Set a path to true to make it and its subpaths public.
 *
 * A broad sport unlock also opens its PRO tools:
 * for example, "/nfl": true opens every NFL page.
 *
 * Non-sports public pages are handled by ProtectedByPathModal.jsx.
 */
export const PROMO_UNLOCKS = {
  // NASCAR optimizers
  "/nascar/cup/optimizer": false,
  "/nascar/oreilly/optimizer": false,
  "/nascar/trucks/optimizer": false,

  // NASCAR contest simulators
  "/nascar/cup/contest-simulator": false,
  "/nascar/oreilly/contest-simulator": false,
  "/nascar/trucks/contest-simulator": false,

  // NASCAR sections
  "/nascar/cup": false,
  "/nascar/oreilly": false,
  "/nascar/trucks": false,
  "/nascar": false,

  // NFL optimizers
  "/nfl/classic/optimizer": false,
  "/nfl/showdown/optimizer": false,
  "/nfl/optimizer": false,

  // NFL contest simulator
  "/nfl/classic/contest-simulator": false,
  "/nfl/contest-simulator": false,

  // NFL section
  "/nfl": false,

  // NBA
  "/nba/optimizer": false,
  "/nba": false,

  // MLB
  "/mlb/optimizer": false,
  "/mlb": false,
};

/* ================= ROUTE ACCESS RULES ================= */

/**
 * Rules are checked in order. The FIRST matching prefix wins.
 *
 * Keep specific tool rules ABOVE the general sport rules:
 * - PRO tools: sport PRO or All Access PRO.
 * - General sport pages: sport LITE/PRO or All Access LITE/PRO.
 *
 * ProtectedByPathModal.jsx checks subscription status and handles
 * public pages, promo unlocks, and individual Cup article access.
 */
export const ROUTE_RULES = [
  /* ---------------- CUP ARTICLES ---------------- */

  // The modal handles the public index and free/paid article checks.
  { prefix: "/nascar/cup/articles", allow: [] },

  /* ---------------- NASCAR PRO TOOLS ---------------- */

  // Optimizers
  {
    prefix: "/nascar/cup/optimizer",
    allow: NASCAR_PRO_ACCESS,
  },
  {
    prefix: "/nascar/oreilly/optimizer",
    allow: NASCAR_PRO_ACCESS,
  },
  {
    prefix: "/nascar/trucks/optimizer",
    allow: NASCAR_PRO_ACCESS,
  },

  // Contest simulators
  {
    prefix: "/nascar/cup/contest-simulator",
    allow: NASCAR_PRO_ACCESS,
  },
  {
    prefix: "/nascar/oreilly/contest-simulator",
    allow: NASCAR_PRO_ACCESS,
  },
  {
    prefix: "/nascar/trucks/contest-simulator",
    allow: NASCAR_PRO_ACCESS,
  },

  /* ---------------- NFL PRO TOOLS ---------------- */

  // Optimizers
  {
    prefix: "/nfl/classic/optimizer",
    allow: NFL_PRO_ACCESS,
  },
  {
    prefix: "/nfl/showdown/optimizer",
    allow: NFL_PRO_ACCESS,
  },
  {
    prefix: "/nfl/optimizer",
    allow: NFL_PRO_ACCESS,
  },

  // Contest simulator: main URL and legacy redirect URL
  {
    prefix: "/nfl/classic/contest-simulator",
    allow: NFL_PRO_ACCESS,
  },
  {
    prefix: "/nfl/contest-simulator",
    allow: NFL_PRO_ACCESS,
  },

  /* ---------------- NBA PRO TOOLS ---------------- */

  {
    prefix: "/nba/optimizer",
    allow: NBA_PRO_ACCESS,
  },

  /* ---------------- MLB PRO TOOLS ---------------- */

  {
    prefix: "/mlb/optimizer",
    allow: MLB_PRO_ACCESS,
  },

  /* ---------------- GENERAL SPORT ACCESS ---------------- */

  // Keep these LAST so they cannot override specific PRO rules.
  {
    prefix: "/nascar",
    allow: NASCAR_ALL,
  },
  {
    prefix: "/nfl",
    allow: NFL_ALL,
  },
  {
    prefix: "/nba",
    allow: NBA_ALL,
  },
  {
    prefix: "/mlb",
    allow: MLB_ALL,
  },
];